// extracted by mini-css-extract-plugin
module.exports = {"form":"Profile-module--form--zZsgR"};